export default {
  showCreateEditView: false,
  showCreateEditBackArrow: false,
}
